import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ChangePasswordModalComponent } from './changePasswordModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChangePassword: undefined;
  }
}
modalRenderer.register('ChangePassword', ChangePasswordModalComponent);
